export const mockWorkouts = [
  "Chest - Heavy",
  "Triceps - Heavy",
  "Back - Heavy",
  "Biceps - Heavy",
  "Shoulders - Heavy",
  "Legs - Heavy",
  "Chest - Light",
  "Triceps - Light",
  "Back - Light",
  "Biceps - Light",
  "Shoulders - Light",
  "Legs - Light"
]